module.exports = __webpack_public_path__ + "static/0064-3ff4cf25b1106f8782ab71a56511f904.png";